import { createLayer } from '../../layers/factory'

export const featureLayers = createLayer({
  title: 'FeatureLayers',
  type: 'group',
  layers: [
    {
      title: 'Rijkswaterstaat',
      type: 'group',
      layers: [
        {
          title: 'Strandpalen',
          type: 'esriFeature',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/GDR/kustlijnzorg/FeatureServer/',
          layers: '2',
        },
        {
          title: 'NAP peilpunten',
          type: 'esriFeature',
          url: 'https://geo.rijkswaterstaat.nl/arcgis/rest/services/GDR/nap/FeatureServer/',
          layers: '0',
        },
      ],
    },

    {
      title: 'Grenzen Nederland',
      type: 'group',
      layers: [
        {
          title: 'Gemeentegrenzen Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'bestuurlijkegebieden:Gemeentegebied',
        },
        {
          title: 'Provinciegrenzen Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/kadaster/bestuurlijkegebieden/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'bestuurlijkegebieden:Provinciegebied',
          // style: {
          //   fill: 'rgba(0,255,0,0.1)',
          //   stroke: { color: 'rgba(0,255,0,1)', width: 2 }
          // }
        },
        {
          title: 'Veiligheidsregio Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'gebiedsindelingen:veiligheidsregio_gegeneraliseerd',
          // style: {
          //   fill: 'rgba(255,165,0,0.1)',
          //   stroke: { color: 'rgba(255,0,0,1)', width: 2 }
          // }
        },
        {
          title: 'GGD Regio Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'gebiedsindelingen:ggdregio_gegeneraliseerd',
        },
        {
          title: 'Wijken Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'gebiedsindelingen:wijk_gegeneraliseerd',
        },
        {
          title: 'Buurten Nederland',
          type: 'wfs',
          url: 'https://service.pdok.nl/cbs/gebiedsindelingen/2025/wfs/v1_0?service=WFS&version=1.1.0&',
          typename: 'gebiedsindelingen:buurt_gegeneraliseerd',
        },
        {
          title: 'Kadaster Percelen',
          type: 'wfs',
          url: 'https://service.pdok.nl/kadaster/kadastralekaart/wfs/v5_0?SERVICE=WFS&version=1.1.0&',
          typename: 'kadastralekaart:Perceel',
        },
        {
          title: 'Kadaster Bebouwing',
          type: 'wfs',
          url: 'https://service.pdok.nl/kadaster/kadastralekaart/wfs/v5_0?SERVICE=WFS&version=1.1.0&',
          typename: 'kadastralekaart:Bebouwing',
          // style: {
          //   fill: 'rgba(255,165,0,0.1)',
          //   stroke: { color: 'rgba(255,0,0,1)', width: 2 }
          // }
        },
      ],
    },

    {
      title: 'Postcodes',
      type: 'group',
      layers: [
        {
          title: 'Postcodes cijfer',
          type: 'esriFeature',
          url: 'https://services.arcgis.com/nSZVuSZjHpEZZbRo/arcgis/rest/services/Postcodevlakken_PC4/FeatureServer/',
          layers: 0,
          // style: {
          //   fill: 'rgba(0,0,0,0.1)',
          //   stroke: { color: 'rgba(0,0,0,255)', width: 1 }
          // }
        },
        {
          title: 'Postcodes compleet',
          type: 'esriFeature',
          url: 'https://services.arcgis.com/nSZVuSZjHpEZZbRo/arcgis/rest/services/Postcodevlakken_PC6/FeatureServer/',
          layers: 0,
          // style: {
          //   fill: 'rgba(0,0,0,0.1)',
          //   stroke: { color: 'rgba(0,0,0,255)', width: 1 }
          // }
        },
      ],
    },

    {
      title: 'Elektriciteitsnet',
      type: 'group',
      layers: [
        {
          title: 'Liander',
          type: 'group',
          layers: [
            {
              title: 'Laagspanningskabel',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '112',
              layer: {
                minZoom: 15,
              },
            },
            {
              title: 'Middenspanningskabel',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '424',
              layer: {
                minZoom: 13.5,
              },
            },
            {
              title: 'Hoogspanningskabel',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '632',
              layer: {
                minZoom: 8.5,
              },
            },
            {
              title: 'Hoogspanningskabel (bovengronds)',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '638',
              layer: {
                minZoom: 8.5,
              },
            },
            {
              title: 'Hoogspanningsstation',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '641',
              layer: {
                minZoom: 8.5,
              },
            },
            {
              title: 'Middenspanningsstation',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '642',
              layer: {
                minZoom: 13.5,
              },
            },
            {
              title: 'Laagspanningstation',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '643',
              layer: {
                minZoom: 8.5,
              },
            },
            {
              title: 'Stationsterrein',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '530',
              layer: {
                minZoom: 13.5,
              },
            },
            {
              title: 'Stationsgebouw',
              type: 'esriFeature',
              url: 'https://services1.arcgis.com/v6W5HAVrpgSg3vts/arcgis/rest/services/Liander_Open_Data_Elektra/FeatureServer/',
              layers: '644',
              layer: {
                minZoom: 13.5,
              },
            },
          ],
        },
        {
          title: 'Stedin',
          type: 'group',
          layers: [
            {
              title: 'Laagspanningsverbindingen',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '2',
              layer: {
                minZoom: 14.9,
              },
              // style: new Style({
              //   stroke: new Stroke({
              //     color: 'rgba(0, 0, 255, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'Middenspanningsverbindingen',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '3',
              layer: {
                minZoom: 13.9,
              },
              // style: new Style({
              //   stroke: new Stroke({
              //     color: 'rgba(197, 0, 255, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'Hoogspanningsverbindingen',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '4',
              layer: {
                minZoom: 12,
              },
            },
            {
              title: 'Laagspanningsstations',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '5',
              layer: {
                minZoom: 14,
              },
              // style: new Style({
              //   fill: new Fill({
              //     color: 'rgba(255, 255, 0, 255)',
              //   }),
              //   stroke: new Stroke({
              //     color: 'rgba(110, 110, 110, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'MiddenLaagspanningsstations',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '6',
              layer: {
                minZoom: 14,
              },
              // style: new Style({
              //   fill: new Fill({
              //     color: 'rgba(0, 255, 255, 255)',
              //   }),
              //   stroke: new Stroke({
              //     color: 'rgba(110, 110, 110, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'Middenspanningsstations',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '7',
              layer: {
                minZoom: 14,
              },
              // style: new Style({
              //   fill: new Fill({
              //     color: 'rgba(0, 168, 132, 255)',
              //   }),
              //   stroke: new Stroke({
              //     color: 'rgba(110, 110, 110, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'Hoogspanningsstations',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '8',
              layer: {
                minZoom: 13,
              },
              // style: new Style({
              //   fill: new Fill({
              //     color: 'rgba(187, 227, 252, 255)',
              //   }),
              //   stroke: new Stroke({
              //     color: 'rgba(110, 110, 110, 255)',
              //     width: 1,
              //   })
              // })
            },
            {
              title: 'Gas',
              type: 'esriFeature',
              url: 'https://services-eu1.arcgis.com/IQto421Ac9MzEmFT/arcgis/rest/services/KM_Gasvervangingsdata/FeatureServer/',
              layers: '1',
              layer: {
                minZoom: 14,
              },
              // style: new Style({
              //   stroke: new Stroke({
              //     color: 'rgba(0,197,255,255)',
              //     width: 1,
              //   })
              // })
            },

          ],
        },
      ],
    },

    {
      title: 'Stedelijk Water',
      type: 'group',
      layers: [
        {
          title: 'Putten',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'BeheerPut',
          layer: {
            minZoom: 16.5,
          },
        },
        {
          title: 'Pompen',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'BeheerPomp',
          layer: {
            minZoom: 14.5,
          },
        },
        {
          title: 'Lozing',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'BeheerLozing',
          layer: {
            minZoom: 15.5,
          },
        },
        {
          title: 'Leidingen',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'BeheerLeiding',
          layer: {
            minZoom: 14.5,
          },
        },
        {
          title: 'Stedelijk Water Bouwwerk',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'BeheerBouwwerk',
        },
        {
          title: 'Aansluitpunt',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'AansluitingPunt',
          layer: {
            minZoom: 17.5,
          },
        },
        {
          title: 'Aansluitleiding',
          type: 'wms',
          url: 'https://service.pdok.nl/rioned/beheerstedelijkwater/wms/v1_0',
          layers: 'AansluitingLeiding',
          layer: {
            minZoom: 17.5,
          },
        },
      ],
    },

    {
      title: 'Aardbevingen',
      type: 'group',
      layers: [
        {
          title: 'Earthquakes Significant Month',
          type: 'geojson',
          url: 'https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/significant_month.geojson',
          // style: new Style({
          //   image: new Circle({
          //     fill: new Fill({
          //       color: 'rgba(255, 0, 0, 255)',
          //     }),
          //     radius: 7,
          //     stroke: new Stroke({
          //       color: 'rgba(0, 0, 0, 255)',
          //       width: 1,
          //     }),
          //   })
          // })
        },
        {
          title: 'Earthquakes all Month',
          type: 'geojson',
          url: 'https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_month.geojson',
          // style: new Style({
          //   image: new Circle({
          //     fill: new Fill({
          //       color: 'rgba(255, 0, 0, 255)',
          //     }),
          //     radius: 7,
          //     stroke: new Stroke({
          //       color: 'rgba(0, 0, 0, 255)',
          //       width: 1,
          //     }),
          //   })
          // })
        },
      ],
    },
  ],
})
